import React, { useEffect } from 'react';
import './countDownProgress.scss';
import { useCounter } from '@hook/useCounter';
import dayjs from 'dayjs';

const CountDownProgressPush = ({ variation }) => {
  const duration = variation?.timerTemplate?.duration || 0;
  const endTime = dayjs(variation?.timerTemplate?.endTime).diff(dayjs());
  const endTimeInSeconds = Math.floor(endTime.valueOf() / 1000);
  const { timer, reset, count } = useCounter({
    duration:
      variation?.timerTemplate?.countDownType === 'END_TIME'
        ? Math.max(endTimeInSeconds, 0)
        : duration || 0,
    local: 'sticky_countdown',
    immediate: true,
    isShowHours: true,
  });

  useEffect(() => {
    reset(true, true);
  }, []);

  return (
    <div className="wrapper">
      <span className="title-counter-progress">
        {variation?.subject || 'Use code MAX50 and get 50% off!'}
      </span>
      <span className="timer-desc-counter-progress">
        {variation?.message || 'Hurry! Coupon expires in'}
      </span>
      <div className="timer-progress-section">
        <div className="progress">
          <div
            className="progressbar"
            style={{
              width: `${((duration - count) / (duration || 1)) * 100}%`,
              backgroundColor: variation?.timerTemplate?.progressBarColor,
            }}
          />
        </div>
        <span
          style={{ color: variation?.timerTemplate?.timeColor }}
          className="timer-counter"
        >
          {timer}
        </span>
      </div>
    </div>
  );
};

export { CountDownProgressPush };
